<template>
  <div class="description-area">
    <img v-if="image" :src="image">
    <div class="description-area__content">
      <h3 v-if="title" v-html="title"/>
      <p v-if="description" v-html="description"/>
      <router-link :to="{ name: 'single-page', params: { slug: $_getPageSlug('Services') } }">
        Perché sceglierci
      </router-link>
    </div>
  </div>
</template>

<script>
import getSinglePages from '@/mixins/getSinglePages.js'

export default {
  name: 'DescriptionArea',
  mixins: [getSinglePages],
  props: {
    title: {
      type: String,
      required: false
    },
    description: {
      type: String,
      required: false
    },
    image: {
      type: String,
      required: false
    }
  }
}
</script>

<style lang="scss">
  @import "./text.scss";
  @import './../../assets/scss/breakpoint.scss';
  @import './../../assets/scss/typo.scss';
  
  .description-area{
    text-align: center;
    margin: 7rem 0 7rem;
    @include media(">=medium"){
      margin: 8rem 0 8rem;
    }
    @include media(">=large"){
      margin: 5rem 0 4rem;
    }
    img{
      width: 160%; height: auto; left: -30%;
      display: block;
      margin: 0 auto;
      @include media(">=small"){
        max-width: 100%; left: 0; width: auto;
      }
    }
    .description-area__content{
      position: absolute; left: 50%; top: 50%;
      transform: translate3d(-50%, -50%, 0);
      
      h3{
        text-align: center;
        margin: 1.5rem 0 2rem;
        @include media(">=large"){
          margin: 1.5rem 0 3rem;
        }
      }
      p{
        text-align: center;
        margin: 0 0 1.5rem;
      }
      a{
        @include button-link($color: #00D6B2, $borderColor: #00D6B2, $hover: #FFF);;
        margin-top: 1rem;
        display: inline-block;
        @include media(">=medium"){
          margin-top: 2rem;
        }
      }
    }
  }

</style>
  